// extracted by mini-css-extract-plugin
export default {"main_container":"login_main_container__b4IUr"};